// extracted by mini-css-extract-plugin
export var buttonContainer = "_7b-1";
export var fontSizeSelect = "_7b-3";
export var formatSelect = "_7b-2";
export var formats = "_7b-4";
export var hidden = "_7b-5";
export var icon = "_7b-6";
export var select = "_7b-0";